import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../../services/api/api';

const isResumeMarketingDepartmentName = (deptName) => {
  const name = String(deptName || '')
    .trim()
    .toLowerCase();
  if (!name) return false;
  if (name === 'resume marketing') return true;
  return name.includes('resume') && name.includes('marketing');
};

/**
 * Allows Resume Marketing TL or Employee to open assigned-candidate edit.
 * Redux `user.employee` from login often has `department` as an id only (not populated),
 * so we mirror Sidebar: resolve department via /employee/profile when needed.
 * Row-level edit rights are still enforced by the API.
 */
const ResumeMarketingAssignedCandidateEditRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const [resolved, setResolved] = useState(null); // null = checking, true = allow, false = deny

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const roleName = String(user?.role?.name || '').trim();
      if (!user || (roleName !== 'TL' && roleName !== 'Employee')) {
        if (!cancelled) setResolved(false);
        return;
      }

      let deptName = user?.employee?.department?.name;
      if (!deptName && (roleName === 'TL' || roleName === 'Employee')) {
        try {
          const res = await api.get('/employee/profile');
          deptName = res?.data?.data?.department?.name;
        } catch {
          deptName = '';
        }
      }

      const inDept = isResumeMarketingDepartmentName(deptName);
      if (!cancelled) setResolved(inDept && (roleName === 'TL' || roleName === 'Employee'));
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (resolved === null) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-content-secondary">
        Checking access…
      </div>
    );
  }

  if (!resolved) {
    return <Navigate to="/resume-marketing/assigned-candidates" replace />;
  }

  return children;
};

export default ResumeMarketingAssignedCandidateEditRoute;
